import { render, staticRenderFns } from "./MenuAmbe.vue?vue&type=template&id=202e301c"
import script from "./MenuAmbe.vue?vue&type=script&lang=js"
export * from "./MenuAmbe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports